export function getTimestamp(date: Date | string): number {
  const _date = typeof date === "string" ? new Date(date) : date;
  return _date.getTime();
}
